import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'INQUIRY' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/handlers.js